export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 120,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('goods_spec_label_orderGoodsSpecName') || '产品规格名称',
    field: 'orderGoodsSpecName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('goods_spec_label_spec') || '产品规格',
    field: 'spec',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'specInfo' }
  },
  {
    title: that.$l('goods_spec_label_inGroupQty') || '规格数量',
    field: 'inGroupQty',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  // {
  //   title: that.$l('goods_spec_label_materialDesc') || '面料说明',
  //   field: 'materialDesc',
  //   minWidth: 300,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('goods_spec_label_accessoriesDesc') || '辅料说明',
  //   field: 'accessoriesDesc',
  //   minWidth: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  {
    title: that.$l('goods_spec_label_technologyDesc') || '工艺要求说明',
    field: 'technologyDesc',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  // {
  //   title: that.$l('goods_spec_label_smallPackageDesc') || '小包装说明',
  //   field: 'smallPackageDesc',
  //   minWidth: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
  // {
  //   title: that.$l('goods_spec_label_innerPackageDesc') || '内包装说明',
  //   field: 'innerPackageDesc',
  //   minWidth: 200,
  //   headerAlign: 'center',
  //   align: 'left',
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  // },
]
